export const fromToTypes = (t) => ({
    from:{name:t("global:complaint.from"), value:"from"},
    to:{name:t("global:complaint.to"), value:"to"}
})